const setCurrentYear = (element) => {
	element.textContent = String(new Date().getFullYear());
};

export default setCurrentYear;
